import(/* webpackMode: "eager" */ "/home/runner/work/web-public/web-public/node_modules/next/dist/client/image-component.js");
